/**
 * Format appointment label with load number when available.
 * Pattern: "Load #12345 · PO-001" or just "PO-001" when no load.
 */
export function formatApptLabel(appt: {
    loadNumber?: string | null;
    customerPoNumber?: string | null;
}): string {
    const po = appt.customerPoNumber || '';
    const load = appt.loadNumber || '';

    if (load && po) return `${load} : ${po}`;
    if (load) return load;
    return po || 'Unassigned';
}
